export const ASSETS_PATH = 'assets';
export const IMAGE_PATH = ASSETS_PATH + '/images';
export const AMAGNO_ICON_PATH = ASSETS_PATH + '/amagno-logo-icons';
export const SVG_ICON_PATH = ASSETS_PATH + '/icons';
